import React, {
    useCallback, useContext, useState
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useModal } from '@jutro/components';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { PolicyService } from 'gw-capability-policy';
import { BreakpointTrackerContext } from '@jutro/layout';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import AddressStandardizationComponent from "premier-capability-policyjob-react/components/AddressStandardizationComponent/AddressStandardizationComponent";
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import styles from '../../envImpairment.module.scss';
import messages from './StorageTanksInformationComponent.messages';
import metadata from './StorageTanksInformationComponent.metadata.json5';
import { useTranslator } from '@jutro/locale';

function StorageTanksInformationComponent(props) {

    const {
        submissionVM,
        updateWizardData,
        StorageTanksInformationPath,
        index,
        modalContext
    } = props;
    const { showConfirm, showAlert } = useModal();
    const breakpoint = useContext(BreakpointTrackerContext);
    const [isEditAddress, setIsEditAddress] = useState(false)
    const [actAddress, setActAddress] = useState(null)
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();
    const modelVM = _.get(submissionVM, StorageTanksInformationPath)
    const jobNumber = submissionVM.value?.quoteID || submissionVM.value?.jobID;
    const accountNumber = _.get(submissionVM, 'baseData.accountNumber.value');
    const translator = useTranslator()

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const DocumentPageService = {
        getDocuments: PolicyService.getDocumentsForPolicyChange,
        generateUploadToken: GatewayDocumentService.generateUploadToken,
        uploadDocument: GatewayDocumentService.uploadDocument,
        removeDocument: GatewayDocumentService.removeDocument,
        downloadDocument: GatewayDocumentService.downloadDocument
    };

    modelVM.isValidationReq.value = true

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${StorageTanksInformationPath}.${changedPath}`;

            if (value === 'new' && changedPath === 'actAdrsPublicID') {
                setIsEditAddress(true)
            }

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [StorageTanksInformationPath, submissionVM, updateWizardData]
    );

    const getAddressOptions = () => {
        const availableValues = submissionVM.value.baseData.account_Ext.accountLocations_Ext.map((actLct) => ({
            code: actLct.publicID,
            name: actLct.displayName
        }));

        return availableValues.concat({
            code: 'new',
            name: '-- Add New --'
        })
    };

    const fillAddressDetails = (value, changedPath) => {
        handleValueChange(value, changedPath)

        if (value === 'new') {
            const model = { country: 'CA', publicID: value }
            const { _xCenter, _dtoName } = modelVM.accountAddressOfLocRisk;
            const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

            _.set(modelVM, 'accountAddressOfLocRisk.value', addressDetailsVM.value)
        } else {

            modelVM.accountAddressOfLocRisk.value = _.find(submissionVM.value.baseData.account_Ext.accountLocations_Ext, (actLct) => actLct.publicID === value);
        }

        handleValueChange(modelVM.accountAddressOfLocRisk.value, 'accountAddressOfLocRisk')
    };

    const setStorageTankIndex = () => {
        if (!_.isUndefined(modelVM.value.tempID)) {
            modelVM.value.stoTan1 = modelVM.value.tempID - 1;
        } else {
            modelVM.value.stoTan1 = 0;
        }

    }

    const setIsSaveButton = () => {
        setIsEditAddress(false)
    }

    const setIsEditButton = () => {
        setActAddress(modelVM.accountAddressOfLocRisk.value)
        setIsEditAddress(true)
    }

    const setIsCancelButton = () => {
        const model = actAddress
        const { _xCenter, _dtoName } = modelVM.accountAddressOfLocRisk;
        const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);

        // eslint-disable-next-line no-secrets/no-secrets
        _.set(modelVM, 'accountAddressOfLocRisk.value', addressDetailsVM.value)
        setIsEditAddress(false);
    }

    const onAddressChange = useCallback((value, changedPath) => {
        const fullPath = `${StorageTanksInformationPath}.accountAddressOfLocRisk.${changedPath}`;

        _.set(submissionVM, `${fullPath}`, value);
        updateWizardData(submissionVM);
    }, [StorageTanksInformationPath, submissionVM, updateWizardData]);

    const deleteStorageTankInformation = useCallback(
        () => {
            const infoListPath = 'lobData.envLin.coverables.envImpairmentCoverable.storageTanks.storageTanksInformation.value';
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );

    const getTodatsDateInJson = () => {
        const todaysDate = new Date()

        return {
            year: todaysDate.getUTCFullYear(),
            month: todaysDate.getUTCMonth(),
            day: todaysDate.getUTCDate()
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showOptional: false,
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        stoTan1: {
            value: setStorageTankIndex()
        },
        actAdrsPublicID: {
            availableValues: getAddressOptions(),
            onValueChange: fillAddressDetails
        },
        ifOthTheDes4: {
            visible: !_.isUndefined(modelVM.value.typOfStoTan3) && modelVM.value.typOfStoTan3 === 'Oth'
        },
        conIfOthTheDes14: {
            visible: !_.isUndefined(modelVM.value.con13) && modelVM.value.con13 === 'Oth'
        },
        ifYesPleProDet28: {
            visible: !_.isUndefined(modelVM.value.hasTheBeeATigTesOr27) && modelVM.value.hasTheBeeATigTesOr27
        },
        ifYesPleProDet30: {
            visible: !_.isUndefined(modelVM.value.havTheBeeAnyChaInPro29) && modelVM.value.havTheBeeAnyChaInPro29
        },
        locRiskddressComponent: {
            labelPosition: 'left',
            model: modelVM.accountAddressOfLocRisk.value || modelVM.accountAddressOfLocRisk,
            viewModelService,
            readOnly: !isEditAddress,
            hideFields: ['addressDescription', 'addressType', 'country'],
            requiredFields: ['addressLine1', 'postalCode'],
            onValueChange: onAddressChange
        },
        editAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && !isEditAddress
        },
        saveAddressButton: {
            visible: modelVM.actAdrsPublicID.value === 'new' || isEditAddress
        },
        cancelAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && isEditAddress
        },
        manDat7: {
            defaultValue: getTodatsDateInJson()
        },
        insDat8: {
            defaultValue: getTodatsDateInJson()
        },
        retDat9: {
            defaultValue: getTodatsDateInJson()
        },
        yeaPipIns21: {
            defaultValue: new Date().getUTCFullYear()
        },
        yeaUndPipWasIns26: {
            defaultValue: new Date().getUTCFullYear()
        },
        storageTankNo: {
            value: index + 1
        },
        isTheUndPip25: {
            defaultValue: false
        },
        havTheBeeAnyChaInPro29: {
            defaultValue: false
        },
        StorageTankInformationAccordionDetails: {
            title: `${translator(messages.storageTankInformation)} ${index + 1}`
        }

    }


    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            modelVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [modelVM, overrideProps]
    );

    const generateUploadToken = useCallback(async () => {
        try {
            const uploadTokenID = await DocumentPageService.generateUploadToken(authHeader)

            return uploadTokenID;
        } catch (e) {
            return showAlert({
                title: commonMessages.errorUploadTitle,
                message: commonMessages.errorGenerateUploadToken,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        }
    }, [DocumentPageService, authHeader, showAlert]);

    const handleUploadCopyOfTightness = async (file) => {
        const documentMetaDataTemplate = {
            jobNumber,
            accountNumber: null,
            policyNumber: null,
            name: file.name,
            sessionID: await generateUploadToken()
        };

        // this.setState({ isLoading: true });
        await GatewayDocumentService.uploadDocument(
            file, documentMetaDataTemplate, authHeader
        ).then((documentUploadData) => {
            if (!_.isEmpty(documentUploadData)) {
                 showAlert({
                    title: messages.documentUploadSuccess,
                    message: messages.documentUploaded,
                    status: 'success',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
                // return this.getDocuments();
            }

            return null;
        }).catch(() => {
            showAlert({
                title: messages.documentUploadFailed,
                message: messages.documentCannotUploaded,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        }).finally(() => {
            // this.setState({ isLoading: false });
        });
    };

    const resolvers = {
        resolveCallbackMap: {
            deleteStorageTankInformation,
            setIsEditButton,
            setIsCancelButton,
            setIsSaveButton,
            onUploadCopyOfTightness: handleUploadCopyOfTightness,
        },
        resolveComponentMap: {
            addressStandardizationComponent: AddressStandardizationComponent
        },
        resolveClassNameMap: styles,
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={modelVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );

}

StorageTanksInformationComponent.propTypes = wizardProps;
export default withRouter(StorageTanksInformationComponent);
